import { useEffect, useState } from "react";
import { toastSuccess } from "../../../components/base/Toast";
import Form from "../../../components/form/Form";
import AddressField from "../../../components/here/AddressField";
import Tagify from "../../../components/tagify/Tagify";
import { API_ROUTES } from "../../../core/Constants";
import { toNormalDate, toPrettyDate, useHub, useSocket } from "../../../core/Global";
import User from "../models/User"
import { HereGeocodeItem, HereGeocodePosition } from "../../../models/MapModels";
import DropDown from "../../../components/form/DropDown";
import Map from "../../../components/here/Map";
import JobMetro from "../../crm/base/models/JobMetro";
import Icon from "../../../components/base/Icon";
import Indicator from "../../../components/base/Indicator";
import FlexRow from "../../../components/base/FlexRow";


type Props = {
    userId?: string
    model?: User
}

export default function AccountTechLiveLocation(props: Props) {

    const hub = useHub();

    const [working, workingSet] = useState<boolean>(true)
    const [updating, updatingSet] = useState<boolean>(false)
    const [location, locationSet] = useState<HereGeocodePosition>()
    const [lastUpdate, lastUpdateSet] = useState<Date>()
    const [isLive, isLiveSet] = useState<boolean>(false)

    const socket = useSocket();

    const fetch = () => {
        hub.Get(API_ROUTES.Technicians + "location/" + props.userId, res => {
            if (res.success && res.data) {
                locationSet(res.data.techLocation);
                lastUpdateSet(res.data.techLocationLastUpdate);
            }
            workingSet(false)
            updatingSet(false)
        })
    }

    useEffect(() => {

        if (props.userId) {
            fetch()

            var socketKey = socket.start(
                skt => {
                    skt.invoke("StartListenToTechLocation", props.userId)
                        .then(() => {

                            skt.on(`techlocation-${props.userId}`, (data, date) => {
                                locationSet(data)
                                lastUpdateSet(date)
                                isLiveSet(true)
                                updatingSet(false)
                            });

                            skt.on(`techlastlocation-${props.userId}`, (data, date) => {
                                locationSet(data)
                                lastUpdateSet(date)
                                isLiveSet(false)
                                updatingSet(false)
                            });

                        })
                }, skt => {
                    skt.off(`techlocation-${props.userId}`)
                    skt.off(`techlastlocation-${props.userId}`)
                    skt.invoke("StopListenToTechLocation", props.userId)
                });


            return () => {
                socket.stop(socketKey);
            };
        }

    }, [props.userId])





    return (
        <div className="card mb-5 mb-xl-10">
            <div className="card-header border-0">
                <div className="card-title m-0">
                    <h3 className="fw-bolder m-0">
                        Live Location
                    </h3>
                </div>
                <div className="card-action">
                    {
                        !working && location &&
                        <FlexRow>
                            <span className="me-2 fs-7">
                                Last Update:
                            </span>
                            {
                                isLive ?
                                    <FlexRow>
                                        <Icon icon="location-arrow" type="solid" className="text-success me-1" />
                                        <span className="text-success">Live</span>
                                    </FlexRow>
                                    :
                                    <span className="fs-7">{toPrettyDate(lastUpdate)}</span>
                            }
                        </FlexRow>
                    }

                </div>
            </div>

            <div className="card-body border-top p-0">

                {
                    working ?
                        <div className="py-20">
                            <Indicator />
                        </div>
                        : location ?
                            <Map id="map-tech-live-loc" build
                                height={700}
                                techMarker={location}
                                defaultCenter={location}
                                zoom={15} />
                            :
                            <div className="py-20 text-center">
                                There is no live location for this Technician!
                            </div>

                }


            </div>

        </div>
    )
}